<!--
 * @Author: fusiyuan 1152054863@qq.com
 * @Date: 2025-08-27 09:44:50
 * @LastEditors: lwk liwkcool@163.com
 * @LastEditTime: 2025-09-11 15:24:39
 * @FilePath: \slbq-web\management-side\src\views\digitalRights\detail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content">
    <div class="table" v-loading="contentLoading">
      <div class="tableBody">
        <el-card class="tableItem">
          <div class="info">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/digitalRights' }"
                >数字版权管理</el-breadcrumb-item
              >
              <el-breadcrumb-item>数字版权登记详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="infoTitle">
              <span>{{ formOptions?.workInfo?.name }}</span>
            </div>
            <div class="infoDesc">{{ formOptions?.workInfo?.description }}</div>
            <div class="infoTime">
              <span class="type">{{
                formOptions?.workInfo?.workCategory?.category
              }}</span>
              <i class="el-icon-date"></i
              >{{
                moment(formOptions?.workInfo?.createdDate).format(
                  "YYYY-MM-DD HH:mm"
                )
              }}
              &nbsp;创建
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="midContent">
      <div>
        <p>{{ formOptions?.workInfo?.workFileName }}</p>
        <ul>
          <li @click="handlePriviewFile" v-if="currentFileType">预览文件</li>
          <li
            @click="
              handleDownloadFile(
                formOptions?.workInfo?.workFileName,
                formOptions?.workInfo?.workUrl
              )
            "
            v-else
          >
            下载文件
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <el-card>
        <div class="top">
          <div class="cover">
            <img
              :src="formOptions?.workInfo?.workThumbnailUrl"
              alt=""
              style="width: 100%; height: 100%"
            />
            <!-- <el-image :src="formOptions?.workInfo?.workUrl" style="width: 100%;height: 100%;"></el-image> -->
          </div>
          <ul>
            <li>
              <p>{{ formOptions?.workInfo?.name }}</p>
              <div>
                <span
                  >文件大小：{{
                    (formOptions?.workInfo?.workFileSize / 1024 / 1024).toFixed(
                      2
                    )
                  }}MB</span
                >
                <span>文件ID：{{ formOptions?.workInfo?.workHash }}</span>
              </div>
            </li>
            <li>
              <el-tag
                type="success"
                v-if="formOptions?.workInfo?.status === 'finished'"
                >登记成功</el-tag
              >
              <el-tag
                type="warning"
                v-if="formOptions?.workInfo?.status === 'waitAudit'"
                >待审核</el-tag
              >
              <el-tag
                type="danger"
                v-if="formOptions?.workInfo?.status === 'failed'"
                >登记失败</el-tag
              >
              <el-tag
                type="danger"
                v-if="formOptions?.workInfo?.status === 'failure'"
                >审核拒绝</el-tag
              >
            </li>
            <li v-if="formOptions?.workInfo?.status === 'failure'" style="color:red">
              审核拒绝原因：{{ formOptions?.auditRejReason }}
            </li>
            <li>
              <span
                @click="
                  () => {
                    drawer = true;
                    activeName = '0';
                  }
                "
                class="links"
                v-if="formOptions.status === 'finished'"
              >
                <i class="el-icon-s-finance"></i>
                查看证据上链证书
                <i class="el-icon-arrow-right"></i>
              </span>
            </li>
          </ul>
        </div>
        <el-divider></el-divider>
        <div class="mid">
            <el-descriptions-item label="区块链名称">
              <p class="link" @click="jumpToOtherWeb">西部国家版权链</p>
            </el-descriptions-item>
            <el-descriptions-item label="上链时间">{{
              moment(formOptions?.workInfo?.createdDate).format(
                "YYYY-MM-DD HH:mm"
              )
            }}</el-descriptions-item>
            <el-descriptions-item label="区域高度">{{
              formOptions?.workInfo?.chainHeight
            }}</el-descriptions-item>
            <el-descriptions-item label="登记主体">{{
              formOptions?.regSubject
            }}</el-descriptions-item>
            <el-descriptions-item label="登记主体证件号码">{{
              formOptions?.subjectCertNum
            }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions>
            <el-descriptions-item label="工作站点">{{
              formOptions?.workPlace?.place
            }}</el-descriptions-item>
            <el-descriptions-item label="著作权人">{{
              formOptions?.copyrightOwner
            }}</el-descriptions-item>
            <el-descriptions-item label="著作权人证件号码">{{
              formOptions?.copyrightOwnerCertNum
            }}</el-descriptions-item>
            <el-descriptions-item label="链上ID">{{
              formOptions?.workInfo?.workTxnId
            }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions>
            <el-descriptions-item label="作品登记哈希值">{{
              formOptions?.workInfo?.workHash
            }}</el-descriptions-item>
          </el-descriptions>
           
        </div>
        <el-divider></el-divider>
        <div class="footer">
          <el-descriptions title="权利声明">
            <el-descriptions-item label="创作完成时间">{{
              formOptions?.finishedDate
            }}</el-descriptions-item>
            <el-descriptions-item label="创作完成地点">{{
              formOptions?.finishedAddr
            }}</el-descriptions-item>
            <el-descriptions-item label="作者">{{
              formOptions?.workInfo?.author
            }}</el-descriptions-item>
            <el-descriptions-item label="发表情况">{{
              formOptions?.published === 1 ? "已发表" : "未发表"
            }}</el-descriptions-item>
            <el-descriptions-item
              label="发表时间"
              v-if="formOptions?.published === 1"
              >{{ formOptions?.publishedTime }}</el-descriptions-item
            >
            <el-descriptions-item
              label="发表方式"
              v-if="formOptions?.published === 1"
              >{{ formOptions?.publishedType }}</el-descriptions-item
            >
            <el-descriptions-item
              label="发表国家"
              v-if="formOptions?.published === 1"
              >{{ formOptions?.publishedCountry }}</el-descriptions-item
            >
            <el-descriptions-item
              label="发表城市"
              v-if="formOptions?.published === 1"
              >{{ formOptions?.publishedCity }}</el-descriptions-item
            >
             <el-descriptions-item v-if="formOptions?.simCetiUrl" label="证明文件">   
              <el-link
                :href="formOptions?.simCetiUrl"
                target="_blank"
                type="primary"
                :underline="false"
                >{{ formOptions?.simCetiUrlName }}</el-link
              ></el-descriptions-item>
          </el-descriptions>
        </div>
      </el-card>
      <br />
      <Similar :similarList="similarList" v-if="formOptions.simCetiUrl"/>
      <template v-if="$route.params.action === 'adt'">
         <el-card>
            <div>
              <el-form label-width="70px">
                  <el-form-item label="审核意见" prop="auditRejReason">
                  <el-input type="textarea" v-model="formOptions.auditRejReason" maxlength="200" show-word-limit/>
               </el-form-item>
               <el-form-item label="" style="text-align: center;">
                  <el-button size="mini" @click="submitForm('failure')">审核拒绝</el-button>
                   <el-button size="mini" type="primary" @click="submitForm('audited')">审核通过</el-button>
               </el-form-item>
              </el-form>
            </div>
         </el-card>
        </el-input>
      </template>
    </div>

    <el-drawer
      :visible.sync="drawer"
      :before-close="beforeDrawerClose"
      destroy-on-close
      append-to-body
      modal-append-to-body
      size="50%"
    >
      <template v-slot:title>
        <span style="font-size: 16px">登记证书</span>
      </template>
      <el-divider></el-divider>
      <div class="drawerContainer">
        <ul>
          <li @click="activeName = '0'" :class="{ active: activeName === '0' }">
            数字内容登记证明
          </li>
          <li @click="activeName = '1'" :class="{ active: activeName === '1' }">
            权利声明
          </li>
        </ul>
        <p>
          {{
            activeName === "0"
              ? "由西部国家版权交易中心出具的版权登记数字证书，具备法律效力。"
              : "记录详细的创造信息，若后续出现纠纷，该声明可以作为证据。"
          }}
        </p>
        <div class="container">
          <p v-if="activeName === '0'">
            证书编号：{{ formOptions?.regCertNum
            }}<i
              class="el-icon-document-copy"
              v-clipboard:copy="formOptions?.regCertNum"
              v-clipboard:success="copySucc"
              v-clipboard:error="copyErr"
            ></i>
          </p>
          <el-image
            @click="priview = true"
            :preview-src-list="[
              activeName === '1'
                ? formOptions?.priStatUrl
                : formOptions?.digitalCopyrightFileUrl,
            ]"
            :src="
              activeName === '1'
                ? formOptions?.priStatUrl
                : formOptions?.digitalCopyrightFileUrl
            "
            class="img"
          ></el-image>
        </div>
        <el-button
          style="float: right"
          class="btn"
          @click="drawer = false"
          type="primary"
          size="mini"
          >确定</el-button
        >
      </div>
    </el-drawer>
    <el-dialog
      :top="activeName != 2 ? '0px' : null"
      :before-close="
        (next) => {
          next();
        }
      "
      :visible.sync="priview"
      width="30%"
      modal-append-to-body
      destroy-on-close
      lock-scroll
      close-on-click-modal
      close-on-press-escape
      append-to-body
    >
      <el-image
        style="
          margin: 0 auto;
          left: 50%;
          transform: translateX(-50%);
          width: 700px;
        "
        :src="
          activeName === '1'
            ? formOptions.priStatUrl
            : activeName === '0'
            ? formOptions?.digitalCopyrightFileUrl
            : formOptions?.workInfo?.workUrl
        "
      ></el-image>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Similar from "@/views/digitalRights/components/similar.vue";
import { registrationAudit } from "@/api/req";

export default {
  mixins: [],
  components: {
    Similar,
  },
  props: {},
  watch: {},
  computed: {
    currentFileType() {
      const filePrefixList = ["JPG", "JPEG", "GIF", "PNG"];
      // , 'AVI', 'WMV', 'MPG', 'MPEG', 'MOV', 'RM', 'RAM', 'SWF', 'FLV', 'MP4'
      const currentfilePrefix = this.formOptions?.workInfo?.workFileName
        ?.split(".")[1]
        ?.toUpperCase();
      return filePrefixList.includes(currentfilePrefix);
    },
    similarList() {
      const result = {
        workUrl: this.formOptions?.workUrl ?? "",
        simCetiUrl: this.formOptions?.simCetiUrl ?? "",
        simCetiUrlName: this.formOptions?.simCetiUrlName ?? "",
        similarImage: this.formOptions?.simImage
          ? JSON.parse(this.formOptions?.simImage)
          : [],
        similarResource: this.formOptions?.simResource
          ? JSON.parse(this.formOptions?.simResource)
          : [],
      };
      return result;
    },
  },
  data() {
    return {
      editNameVisable: false,
      formOptions: {},
      contentLoading: false,
      activeName: "0",
      priview: false,
      drawer: false,
      digitalCopyrightFileUrl: "",
      priStatUrl: "",
      editTargetData: {},
      regCertNum: "",
    };
  },
  created() {},
  methods: {
    submitForm(status) {
      if (status === "failure") {
        if (!this.formOptions.auditRejReason) {
          this.$message({
            message: "请输入拒绝原因",
            type: "warning",
          });
          return;
        }
      }
      this.$ajax
        .post(registrationAudit, {
          regInfoId: this.formOptions.id,
          status,
          auditRejReason: this.formOptions.auditRejReason,
        })
        .then((res) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$router.push({
            path: "/digitalRights",
          });
        });
    },
    handleDownloadFile(fileName, fileUrl) {
      if (fileName.indexOf(".txt") === -1) {
        window.open(fileUrl, "_blank");
        return;
      }
      const download = (blob, fileName) => {
        const a = document.createElement("a");
        a.download = window.decodeURIComponent(fileName);
        a.href = window.URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
      var ajax = new XMLHttpRequest();
      ajax.open("GET", fileUrl, true);
      ajax.responseType = "blob";
      ajax.onload = function (e) {
        download(e.target.response, fileName);
      };
      setTimeout(function () {
        ajax.send();
      }, 0);
    },
    handlePriviewFile() {
      this.activeName = "2";
      this.priview = true;
    },
    getList(description) {
      this.formOptions.workInfo.description = description;
    },
    editName(value) {
      this.editTargetData = value.workInfo;
      this.editNameVisable = true;
    },
    remove() {
      this.$confirm(
        "删除作品后，作品以及包含的文件将无法恢复，您确定要删除作品吗?",
        "您确定要删除作品么？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        console.log("1", 1);
      });
    },
    //点击复制
    copySucc() {
      this.$message({
        showClose: true,
        message: "复制成功",
        type: "success",
        center: true,
        duration: 1000,
      });
    },
    copyErr() {
      this.$message({
        showClose: true,
        message: "复制失败",
        type: "error",
        center: true,
        duration: 1000,
      });
    },
    beforeDrawerClose(next) {
      this.digitalCopyrightFileUrl = "";
      this.priStatUrl = "";
      this.activeName = "0";
      this.regCertNum = "";
      next();
    },
    jumpToOtherWeb() {
      window.open("http://ncc.slbqw.com/#/", "_blank");
    },
  },
  mounted() {
    const data = sessionStorage.getItem("curData");
    this.formOptions = data ? JSON.parse(data) : {};
    this.contentLoading = true;
    // this.formOptions = {};
    this.contentLoading = false;
  },
  updated() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
html {
  font-size: 100px;
}
.table {
  padding-top: 10px;

  .tableBody {
    max-height: 500px;
    overflow: auto;
    .tableItem {
      padding: 12px 20px;
      color: #787878;
      margin-bottom: 20px;
      /deep/.el-card__body {
        display: flex;
        padding: 0px;
        width: 100%;
        justify-content: space-between;
        .info {
          box-sizing: border-box;
          padding-left: 20px;
          min-width: 640px;
          min-height: 134px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-right: 30px;
          .infoTitle {
            font-size: 30px;
            display: flex;
            span {
              color: #121214;
              padding-right: 24px;
              font-weight: bolder;
            }
          }
          .infoDesc {
            /* padding-bottom: 8px; */
            max-height: 50px;
            overflow: auto;
            margin-bottom: 10px;
          }
          .infoTime {
            .type {
              line-height: 16px;
              margin-right: 10px;
              background: url("~@/assets/images/type_bg.png") no-repeat;
              background-size: 100% 100%;
              color: #fff;
              text-align: center;
              // min-width: 84px;
              padding: 2px 15px 2px 22px;
            }
          }
        }
        .operate {
          width: 380px;
          font-weight: bolder;
          color: #707072;
          font-size: 14px;
          display: flex;
          justify-content: flex-end;
          span {
            padding: 2px 5px;
            border-radius: 5px;
            border: solid 1px #ededef;
            cursor: pointer;
            margin-left: 20px;
          }
        }
      }
    }
  }

  .tableFooter {
    float: right;
    padding-top: 20px;
    /deep/.el-pagination {
      button,
      li {
        border-radius: 4px;
        background-color: #fff;
        &:hover {
          color: #000e7b;
        }
        &.active {
          color: #000e7b;
          border: solid 1px #000e7b;
          background-color: #fff;
        }
      }
    }
  }
}

.content {
  box-sizing: border-box;
  background-color: #f4f4f4;
  height: 30px;
  height: 100%;
  padding: 0 15px;
  .midContent {
    height: 40px;
    padding-bottom: 10px;
    > div {
      display: flex;
      justify-content: space-between;
      line-height: 40px;
      p {
        color: #7d7d7d;
      }
      ul {
        list-style: none;
        display: flex;
        color: #00006e;
        a {
          color: #00006e;
          text-decoration: none;
        }
        li {
          font-weight: bold;
          cursor: pointer;
          padding-right: 10px;
          color: #4e89ff;
          i {
            color: #7d7d7d;
          }
        }
      }
    }
  }
  .container {
    padding-bottom: 20px;
    /deep/.el-card__body {
      padding: 30px;
      .cover {
        width: 230px;
        height: 154px;
      }
      .top {
        display: flex;
        ul {
          padding: 10px 0px;
          padding-left: 26px;
          list-style: none;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          li {
            p {
              font-weight: bold;
              font-size: 16px;
              color: #444444;
            }
            div {
              display: flex;
              font-size: 14px;
              justify-content: space-around;
              > span {
                padding-right: 20px;
              }
            }
            > .links {
              background-color: #36c2cf;
              color: #ffffff;
              display: inline-block;
              font-size: 14px;
              padding: 8px 12px;
              font-weight: bold;
              border-radius: 8px;
              cursor: pointer;
              .el-icon-s-finance {
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
}

/deep/.el-breadcrumb__item .el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
  color: #000e7b !important;
}
.link {
  color: #4e89ff;
  cursor: pointer;
}

.drawerContainer {
  padding: 0 24px;
  padding-bottom: 50px;
  ul {
    list-style: none;
    display: flex;
    li {
      padding: 12px 16px;
      border-radius: 6px;
      border: solid 1px #9e9e9e;
      margin-right: 36px;
      font-size: 16px;
      cursor: pointer;
      &.active {
        color: #132b88;
        border-color: #132b88;
      }
    }
  }
  > p {
    padding: 20px 0px;
    font-size: 16px;
    color: #9e9e9e;
  }
  .container {
    background-color: #f6f6f6;
    height: 700px;
    overflow: auto;
    width: 100%;
    position: relative;
    box-sizing: border-box;
    .img {
      width: 475px;
      height: 680px;
      position: absolute;
      left: 50%;
      padding-top: 20px;
      transform: translateX(-50%);
      cursor: pointer;
    }
    p {
      position: absolute;
      z-index: 9;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      padding: 10px 0;
      font-size: 16px;
      .el-icon-document-copy {
        padding-left: 10px;
        display: inline-block;
        color: #122d88;
        font-weight: bolder;
        cursor: pointer;
      }
    }
  }
  .btn {
    margin-top: 15px;
  }
}

/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog {
  background-color: transparent;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-drawer__header {
  margin-bottom: 0px !important;
}
/deep/.el-breadcrumb__inner.is-link:hover {
  color: #122c86;
}
.el-dialog__wrapper {
  overflow: hidden;
}
</style>
